/**
 * @desc 导出指定仓库sku库存信息
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(params: API.stock.stockSku.warehouseSku.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/sku/export/warehouseSku`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
